import React, {useEffect} from 'react';
import {
	Dialog, DialogTitle, DialogContent, DialogActions,
	Button, TextField, MenuItem, CircularProgress
} from '@material-ui/core';
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import Select from 'react-select/creatable';

const transactionTypes = [
	{value: 'credit', label: 'Credit'},
	{value: 'debit', label: 'Debit'}
];

const reasons = [
	{value: 'marketing', label: 'Marketing'},
	{value: 'order', label: 'Order'},
	{value: 'refund', label: 'Refund'},
	{value: 'other', label: 'Other'}
];

const AddWalletTransactionDialog = (
	{
		open,
		onClose,
		onSubmit,
		transactionType,
		setTransactionType,
		amount,
		setAmount,
		reason,
		setReason,
		comment,
		setComment,
		errors,
		isSubmitting,
		orderNumber,
		recentOrders,
		recentOrderLoading,
		setOrderNumber
	}
) => {
	const customStyles = {
		control: (base, state) => ({
			...base,
			border: 'none',
			borderBottom: `2px solid #000000`,
			borderRadius: 0,
			boxShadow: 'none',
			backgroundColor: 'transparent',
			'&:hover': {
				borderBottom: '2px solid #0539b2',
			},
			minHeight: '36px',
		}),
		input: (base) => ({
			...base,
			margin: 0,
			padding: 0,
		}),
		placeholder: (base) => ({
			...base,
			color: '#aaa',
			fontSize: '14px',
		}),
		option: (base, state) => ({
			...base,
			backgroundColor: state.isFocused ? '#f5f5f5' : 'white',
			color: '#333',
			fontSize: '14px',
		}),
		menuPortal: (base) => ({
			...base,
			zIndex: 9999,
		}),
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>
				<AccountBalanceWalletIcon
					fontSize="medium"
					style={{marginRight: 8, color: '#3f51b5'}}
				/>
				Update Funds
			</DialogTitle>
			<DialogContent dividers>
				{!recentOrderLoading && (
					<Select
						options={recentOrders}
						styles={customStyles}
						placeholder="Select order number"
						onKeyDown={(e) => {
							if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
								e.preventDefault();
							}
						}}
						value={orderNumber}
						onChange={setOrderNumber}
						isClearable
						menuPortalTarget={document.body}
						menuPosition="fixed"
					/>
				)}
				<TextField
					select
					fullWidth
					label="Transaction Type"
					value={transactionType}
					onChange={(e) => setTransactionType(e.target.value)}
					error={errors.transactionType}
					disabled={isSubmitting}
					margin="dense"
					required
				>
					{transactionTypes.map((opt) => (
						<MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
					))}
				</TextField>

				<TextField
					type="number"
					fullWidth
					label="Amount (USD)"
					value={amount}
					onChange={(e) => setAmount(e.target.value)}
					error={errors.amount}
					disabled={isSubmitting}
					margin="dense"
					required
				/>

				<TextField
					select
					fullWidth
					label="Reason"
					value={reason}
					onChange={(e) => setReason(e.target.value)}
					error={errors.reason}
					disabled={isSubmitting}
					margin="dense"
					required
				>
					{reasons.map((opt) => (
						<MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
					))}
				</TextField>

				<TextField
					fullWidth
					label="Comment"
					multiline
					rows={3}
					value={comment}
					onChange={(e) => setComment(e.target.value)}
					disabled={isSubmitting}
					margin="dense"
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={isSubmitting} color="default">
					Close
				</Button>
				<Button onClick={onSubmit} disabled={isSubmitting} color="primary" variant="contained">
					{isSubmitting && (
						<CircularProgress size={16} color="inherit" style={{marginRight: 8}}/>
					)}
					Update
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddWalletTransactionDialog;
